/*
* Story Theme
*
* Use this file to add custom Javascript to Story.  Keeping your custom
* Javascript in this fill will make it easier to update Story. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {
  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  /*$(document).ready(function() {
  function updateCartItemCount() {
    $.ajax({
      type: 'GET',
      url: '/cart.json',
      cache: false,
      dataType: 'json',
      success: function(cart) {
        const itemCount = cart.item_count;
        const textElement = $('#cart-item-text');
        const text = itemCount === 1 ? 'item is' : 'items are';

        // You can modify the text as needed to suit your store's language and design
        const dynamicText = itemCount;

        textElement.text(dynamicText);
      }
    });
  }


  updateCartItemCount();
  Shopify.onCartUpdate = updateCartItemCount;*/

  console.log("fonctionne");
  
  // open-first-accordion-force.js
  
  const GROUP_SEL     = '[data-accordion-group]';
  const BODY_SEL      = '[data-accordion-body], .accordion__body';
  const TRIGGER_ATTR  = 'data-accordion-trigger';
  const SECTION_SEL   = '[data-section-id]';
  const OPEN_CLASS    = 'accordion-is-open';
  const MOBILE_ATTR   = 'data-accordion-body-mobile';
  const MARK_ATTR     = 'data-first-accordion-opened';

  const mediumBp = () => (window.theme?.sizes?.medium ?? 990);
  const isMobileAllowed = (el) => !el?.hasAttribute(MOBILE_ATTR) || window.innerWidth < mediumBp();

  const isVisiblyOpen = (el) => {
    if (!el) return false;
    const cs = getComputedStyle(el);
    return cs.display !== 'none' &&
           cs.visibility !== 'hidden' &&
           (el.scrollHeight > 0 || cs.maxHeight === 'none' || cs.height !== '0px');
  };

  // Force visible using INLINE !important so it beats other inline values.
  const forceVisibleInline = (body) => {
    // remove hard-hiding attributes if present
    body.removeAttribute('hidden');
    body.removeAttribute('inert');
    body.setAttribute('aria-hidden', 'false');
    // apply strong inline overrides
    body.style.setProperty('display',    'block',    'important');
    body.style.setProperty('visibility', 'visible',  'important');
    body.style.setProperty('opacity',    '1',        'important');
    body.style.setProperty('overflow',   'visible',  'important');
    body.style.setProperty('height',     'auto',     'important');
    body.style.setProperty('max-height', '9999px',   'important'); // large enough to stay open
    body.classList.remove('is-transitioning');
  };

  const openWithGuard = (trigger, body) => {
    if (!body) return;

    // 1) Try the theme's way first:
    if (trigger) {
      trigger.classList.add(OPEN_CLASS);
      trigger.setAttribute('aria-expanded', 'true');
      if (typeof trigger.click === 'function') trigger.click();
    }

    // 2) After a tick, enforce visible state via inline !important
    const start = performance.now();
    const guardMs = 2000; // keep guarding for up to 2s
    let rafId = null;
    let observer = null;

    const keepOpen = () => {
      forceVisibleInline(body);
      if (performance.now() - start < guardMs) {
        rafId = requestAnimationFrame(keepOpen);
      } else {
        if (observer) observer.disconnect();
        cancelAnimationFrame(rafId);
      }
    };

    // Attribute observer to catch theme re-writes to `style`
    observer = new MutationObserver((muts) => {
      for (const m of muts) {
        if (m.type === 'attributes' && m.attributeName === 'style') {
          // If it was re-hidden, immediately re-assert visibility
          if (!isVisiblyOpen(body)) forceVisibleInline(body);
        }
      }
    });
    observer.observe(body, { attributes: true, attributeFilter: ['style'] });

    // kick it off after the theme processes the click
    requestAnimationFrame(() => {
      if (!isVisiblyOpen(body)) forceVisibleInline(body);
      keepOpen();
    });
  };

  const openFirstInGroup = (group) => {
    if (!group || group.hasAttribute(MARK_ATTR)) return;

    // Find the first body in this group
    const firstBody = group.querySelector(BODY_SEL);
    if (!firstBody || !firstBody.id) {
      group.setAttribute(MARK_ATTR, 'skipped');
      return;
    }
    if (!isMobileAllowed(firstBody)) { // respect mobile-only accordions
      group.setAttribute(MARK_ATTR, 'true');
      return;
    }

    // Find a matching trigger (prefer same section)
    const section = firstBody.closest(SECTION_SEL) || group;
    const trigger =
      section.querySelector(`[${TRIGGER_ATTR}="${firstBody.id}"]`) ||
      document.querySelector(`[${TRIGGER_ATTR}="${firstBody.id}"]`);

    openWithGuard(trigger, firstBody);
    group.setAttribute(MARK_ATTR, 'true');
  };

  const openAllFirst = (root = document) => {
    root.querySelectorAll(GROUP_SEL).forEach(openFirstInGroup);
  };

  const kickoff = () => {
    openAllFirst();
    // extra passes to outlast late binds
    requestAnimationFrame(openAllFirst);
    setTimeout(openAllFirst, 150);
    setTimeout(openAllFirst, 500);
    window.addEventListener('load', () => setTimeout(openAllFirst, 150), { once: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kickoff, { once: true });
  } else {
    kickoff();
  }

  // respond to dynamic changes
  document.addEventListener('shopify:section:load',   (e) => openAllFirst(e.target || document));
  document.addEventListener('shopify:section:select', (e) => openAllFirst(e.target || document));
  document.addEventListener('theme:resize',           () => {
    document.querySelectorAll(GROUP_SEL).forEach(g => g.removeAttribute(MARK_ATTR));
    openAllFirst();
  });

  // safety net: process newly added groups
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      if (m.type !== 'childList') continue;
      m.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches?.(GROUP_SEL)) openFirstInGroup(node);
        if (node.querySelector) openAllFirst(node);
      });
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();